<template>
  <div class="loadingbox">
    <ul class="TransitionBox">
      <li class="TransitionImg TransitionLoadingImg" v-if="Loading.type == 1"><img src="/static/images/loading.gif"></li>
      <li class="TransitionImg TransitionNullImg" v-else-if="Loading.type == 2"><img src="/static/images/null.png"></li>
      <li class="TransitionImg TransitionErrorImg" v-else-if="Loading.type == 3"><img src="/static/images/error.png"></li>
      <li class="TransitionTxt" v-text="Loading.txt"></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TemplateOne',
  props:["Loading"]
}
</script>

<style scoped>
  .loadingbox{
    position: fixed;
    top:0;left:0;
    bottom:0;right:0;
    background-color: #FFF;
  }
  .TransitionBox{
    display: table;
    margin:30px auto;
  }
  .TransitionImg img{
    display: table;
    margin: 0 auto;
  }
  .TransitionLoadingImg img,.TransitionNullImg img{
    width: 200px;
  }
  .TransitionErrorImg img{
    width: 150px;
  }
  .TransitionTxt{
    font-size: 15px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue